"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "PageType", {
  enumerable: true,
  get: function () {
    return _routeValidators.PageType;
  }
});
exports.Route = Route;
exports.Router = void 0;
_Object$defineProperty(exports, "isRoute", {
  enumerable: true,
  get: function () {
    return _routeValidators.isValidRoute;
  }
});
exports.routes = void 0;
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/assign"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _reduceRight = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce-right"));
var _react = _interopRequireWildcard(require("react"));
var _activeRouteLoader = require("./active-route-loader");
var _AuthenticatedRoute = require("./AuthenticatedRoute");
var _links = require("./links");
var _location = require("./location");
var _PageLoadingContext = require("./PageLoadingContext");
var _params = require("./params");
var _routeValidators = require("./route-validators");
var _routerContext = require("./router-context");
var _splashPage = require("./splash-page");
var _util = require("./util");
var _jsxRuntime = require("react/jsx-runtime");
// namedRoutes is populated at run-time by iterating over the `<Route />`
// components, and appending them to this object.
// Has to be `const`, or there'll be a race condition with imports in users'
// projects
const namedRoutes = {};

/**
 *
 * Route is now a "virtual" component
 * it is actually never rendered. All the page loading logic happens in active-route-loader
 * and all the validation happens within utlity functions called from the Router
 */
exports.routes = namedRoutes;
function Route(_props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
}
const Router = _ref => {
  let {
    useAuth,
    paramTypes,
    pageLoadingDelay,
    trailingSlashes = 'never',
    children
  } = _ref;
  return (
    /*#__PURE__*/
    // Level 1/3 (outer-most)
    // Wrap it in the provider so that useLocation can be used
    (0, _jsxRuntime.jsx)(_location.LocationProvider, {
      trailingSlashes: trailingSlashes,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LocationAwareRouter, {
        useAuth: useAuth,
        paramTypes: paramTypes,
        pageLoadingDelay: pageLoadingDelay,
        children: children
      })
    })
  );
};
exports.Router = Router;
const LocationAwareRouter = _ref2 => {
  let {
    useAuth,
    paramTypes,
    pageLoadingDelay,
    children
  } = _ref2;
  const location = (0, _location.useLocation)();
  const {
    pathRouteMap,
    hasHomeRoute,
    namedRoutesMap,
    NotFoundPage,
    activeRoutePath
  } = (0, _react.useMemo)(() => {
    return (0, _util.analyzeRoutes)(children, {
      currentPathName: location.pathname,
      // @TODO We haven't handled this with SSR/Streaming yet.
      // May need a babel plugin to extract userParamTypes from Routes.tsx
      userParamTypes: paramTypes
    });
  }, [location.pathname, children, paramTypes]);

  // Assign namedRoutes so it can be imported like import {routes} from 'rwjs/router'
  // Note that the value changes at runtime
  (0, _assign.default)(namedRoutes, namedRoutesMap);

  // The user has not generated routes if the only route that exists is the
  // not found page, and that page is not part of the namedRoutes object
  const hasGeneratedRoutes = (0, _keys.default)(namedRoutes).length > 0;
  const shouldShowSplash = !hasHomeRoute && location.pathname === '/' || !hasGeneratedRoutes;
  if (shouldShowSplash && typeof _splashPage.SplashPage !== 'undefined') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_splashPage.SplashPage, {
      hasGeneratedRoutes: hasGeneratedRoutes,
      allStandardRoutes: pathRouteMap
    });
  }

  // Render 404 page if no route matches
  if (!activeRoutePath) {
    if (NotFoundPage) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_routerContext.RouterContextProvider, {
        useAuth: useAuth,
        paramTypes: paramTypes,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_params.ParamsProvider, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PageLoadingContext.PageLoadingContextProvider, {
            delay: pageLoadingDelay,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_activeRouteLoader.ActiveRouteLoader, {
              spec: (0, _util.normalizePage)(NotFoundPage),
              path: location.pathname
            })
          })
        })
      });
    }
    return null;
  }
  const {
    path,
    page,
    name,
    redirect,
    whileLoadingPage,
    wrappers = [],
    setProps,
    setId
  } = pathRouteMap[activeRoutePath];
  if (!path) {
    throw new Error(`Route "${name}" needs to specify a path`);
  }

  // Check for issues with the path.
  (0, _util.validatePath)(path, name || path);
  const {
    params: pathParams
  } = (0, _util.matchPath)(path, location.pathname, {
    userParamTypes: paramTypes
  });
  const searchParams = (0, _util.parseSearch)(location.search);
  const allParams = {
    ...searchParams,
    ...pathParams
  };

  // Level 2/3 (LocationAwareRouter)
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_routerContext.RouterContextProvider, {
    useAuth: useAuth,
    paramTypes: paramTypes,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_params.ParamsProvider, {
      allParams: allParams,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PageLoadingContext.PageLoadingContextProvider, {
        delay: pageLoadingDelay,
        children: [redirect && /*#__PURE__*/(0, _jsxRuntime.jsx)(_links.Redirect, {
          to: (0, _util.replaceParams)(redirect, allParams)
        }), !redirect && page && /*#__PURE__*/(0, _jsxRuntime.jsx)(WrappedPage, {
          wrappers: wrappers,
          routeLoaderElement: /*#__PURE__*/(0, _jsxRuntime.jsx)(_activeRouteLoader.ActiveRouteLoader, {
            path: path,
            spec: (0, _util.normalizePage)(page),
            params: allParams,
            whileLoadingPage: whileLoadingPage,
            ...setProps
          }),
          setProps: setProps
        }, setId)]
      })
    })
  });
};
/**
 * This is effectively a Set (without auth-related code)
 *
 * This means that the <Set> and <Private> components become "virtual"
 * i.e. they are never actually Rendered, but their props are extracted by the
 * analyze routes function.
 *
 * This is so that we can have all the information up front in the routes-manifest
 * for SSR, but also so that we only do one loop of all the Routes.
 */
const WrappedPage = /*#__PURE__*/(0, _react.memo)(_ref3 => {
  let {
    wrappers,
    routeLoaderElement,
    setProps
  } = _ref3;
  // @NOTE: don't mutate the wrappers array, it causes full page re-renders
  // Instead just create a new array with the AuthenticatedRoute wrapper
  let wrappersWithAuthMaybe = wrappers;
  if (setProps.private) {
    if (!setProps.unauthenticated) {
      throw new Error('You must specify an `unauthenticated` route when marking a Route as private');
    }
    wrappersWithAuthMaybe = [_AuthenticatedRoute.AuthenticatedRoute, ...wrappers];
  }
  if (wrappersWithAuthMaybe.length > 0) {
    // If wrappers exist e.g. [a,b,c] -> <a><b><c><routeLoader></c></b></a> and returns a single ReactNode
    // Wrap AuthenticatedRoute this way, because if we mutate the wrappers array itself
    // it causes full rerenders of the page
    return (0, _reduceRight.default)(wrappersWithAuthMaybe).call(wrappersWithAuthMaybe, (acc, wrapper) => {
      return /*#__PURE__*/_react.default.createElement(wrapper, {
        ...setProps
      }, acc ? acc : routeLoaderElement);
    }, undefined);
  }
  return routeLoaderElement;
});